import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';
import UserCurrencyStore from './user_currency_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getDestAddr,
  fetchDestAddr,
  sendCoins,
};

const CRYPTO_COIN_ID = 'dank_coin';
let g_destAddr: string | null = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  UserStore.addChangeListener(_onUserChange);
  done && done();
}
function _onUserChange(reason: string) {
  if (reason === 'logout') {
    g_destAddr = null;
    _emit('update');
  }
}

function isReady() {
  return true;
}
function getDestAddr() {
  return g_destAddr;
}

function fetchDestAddr(done = null) {
  const opts = {
    url: '/client/1/crypto_coin/incoming',
    body: {
      crypto_coin_id: CRYPTO_COIN_ID,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('CryptoStore.fetchDestAddr: err:', err, body);
    } else {
      g_destAddr = body.dest_addr;
    }
    done && done(err, g_destAddr);
  });
}

function sendCoins(params, done) {
  const opts = {
    url: '/client/1/crypto_coin/outgoing',
    body: {
      idempotent_key: params.idempotent_key,
      crypto_coin_id: CRYPTO_COIN_ID,
      dest_addr: params.dest_addr,
      amount: params.amount,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err === 409) {
      UserCurrencyStore.fetchCurrency('dank_coin');
      err = null;
    } else if (err) {
      util.errorLog('CryptoStore.sendCoins: err:', err, body);
    } else if (body && body.debit_list) {
      UserCurrencyStore.debitList(body.debit_list);
    }
    done && done(err);
  });
}
